import * as intl from "@arcgis/core/intl";
import { memo, useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { LANGUAGES } from "../../../../../data/constants";
import { isWidgetDisplayed } from "../../../../../esri/widgets/expandUtils";
import { ConfigContext } from "../../../../../utils/ConfigContext";
import { MdTranslate } from "../../../../Icons";
import Section from "../UI/Section/Section";

const LanguageSelection = ({ expanded, ...props }) => {
  const { t, i18n } = useTranslation("common");

  const activeModule = useSelector((state) => state.activeModule);
  const { config, setActiveLanguage, activeLanguage } =
    useContext(ConfigContext);

  const hideLanguageSelection = useMemo(() => {
    return (
      !isWidgetDisplayed(config, "LanguageSwitcher") ||
      !(config.supportedLngs && config.supportedLngs.length > 1)
    );
  }, [config]);

  if (hideLanguageSelection) return null;

  return (
    <Section
      {...props}
      className="onboarding-language"
      expanded={expanded}
      options={config.supportedLngs.map((lang) => {
        const item = LANGUAGES[lang];
        return {
          selected: i18n.language === lang,
          title: item.title,
          icon: (
            <span style={{ fontWeight: 600 }}>
              {item.displayCode.toUpperCase()}
            </span>
          ),
          onClick: () => {
            const languageConfig = {
              showModules: false,
              languageModule: activeModule,
            };
            localStorage.setItem(
              "languageConfig",
              JSON.stringify(languageConfig)
            );
            setActiveLanguage(lang);
            i18n
              .changeLanguage(lang, () => {
                if (lang === "zh-cn") {
                  intl.setLocale("zh-CN");
                } else {
                  intl.setLocale(lang);
                }
              })
              .then(() => {
                // window.location.reload()
              });
          },
        };
      })}
      title={t("screen.widget.LanguageSwitcher.name")}
      information={t("screen.widget.LanguageSwitcher.information")}
      Icon={MdTranslate}
      widgetName="LanguageSwitcher"
    />
  );
};

export default memo(LanguageSelection);
